const FRAIL_CALENDAR_AREA = {
  ITABASHI: 1,
  CHIYODA: 2,
};

const FRAIL_CALENDAR_AREA_LINK = {
  [FRAIL_CALENDAR_AREA.ITABASHI]: "https://www.city.itabashi.tokyo.jp",
  [FRAIL_CALENDAR_AREA.CHIYODA]: "https://www.city.chiyoda.lg.jp",
};

export { FRAIL_CALENDAR_AREA_LINK };
